import {Api} from "./Api";
import configs from "./config.json";
import {UserApi} from "./UserApi";


export class CategoryApi {
    static get = async (data,page, response, error) => {
        await Api.get(`${configs.category}/${data}?${page?`page=${page}`:''}`, null, response, UserApi.getAuthorizedHeader(), error);

    }

    static getAll = async ( response, error) => {
        await Api.get(`${configs.category}`, null, response, UserApi.getAuthorizedHeader(), error);
    }

    static insert = async (data, response, error) => {
        await Api.post(`${configs.category}`, data, response, UserApi.getAuthorizedHeader(), error);

    }

    static update = async (data, id, response, error) => {
        await Api.put(`${configs.category}/${id}`, data, response, UserApi.getAuthorizedHeader(), error);

    }

    static delete = async (id, response, error) => {
        await Api.delete(`${configs.category}/${id}`, null, response, UserApi.getAuthorizedHeader(), error);
    }
}